import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {},
  loading: false,
  modal: {
    default: false,
  },
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    startLoading(state) {
      debugger;
      state.loading = true;
    },

    stopLoading(state) {
      state.loading = false;
    },

    toggleModal(state, action) {
      const isOpenModal = state.modal[action.payload];
      if (typeof isOpenModal === 'undefined' || isOpenModal == null) {
        state.modal[action.payload] = true;
      } else {
        state.modal[action.payload] = !isOpenModal;
      }
    },
    saveUserInfo(state, action) {
      state.userInfo = action.payload.userInfo;
    },
  },
});

// ===========================================================
// >>>> FOR EXPORTS <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// ===========================================================
const appState = (state) => state.app;
export const appSelector = {
  loading: createSelector(appState, (app) => app.loading),
  modal: (name) => createSelector(appState, (app) => app.modal[name]),
  userInfo: createSelector(appState, (app) => app.userInfo),
};
export const appActions = appSlice.actions;
export const appReducer = appSlice.reducer;
